var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerRepresentative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    id: "CustomerRepresentative",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 41.436,
    y1: 34.186,
    y2: 34.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M41.42,55.51c0-0.02,0.01-0.04,0.01-0.05c0-0.01-0.01-0.03-0.01-0.04c0-0.01,0-0.03,0-0.04l-0.51-3.03 c-0.3-3.84-2.99-7.1-6.71-8.11l-6.07-1.65l-2.24-3.08c-0.08-0.11-0.21-0.18-0.34-0.2c-0.03,0-0.07,0.01-0.1,0.01v-0.99 c0.54-0.39,1.04-0.82,1.48-1.31h1.04c1.9,0,3.45-1.44,3.66-3.29c0.39-0.15,0.67-0.53,0.67-0.97V27.2c0-0.57-0.46-1.03-1.02-1.05 c0.74-3.07,0.42-6.08-0.96-8.54c-1.27-2.27-3.37-3.91-5.91-4.61c-4.47-1.3-8.47-0.41-11.27,2.51c-2.66,2.78-3.7,6.97-2.73,10.63 h-0.05c-0.58,0-1.05,0.47-1.05,1.05v5.56c0,0.58,0.47,1.05,1.05,1.05h2.44c0.61,1.92,1.66,3.41,3.18,4.5v1.02 c-0.03,0-0.07-0.01-0.1-0.01c-0.14,0.02-0.26,0.09-0.34,0.2l-2.24,3.08l-6.07,1.65c-3.72,1.01-6.41,4.27-6.7,8.07l-0.52,3.07 c-0.02,0.14,0.02,0.29,0.11,0.4c0.09,0.11,0.23,0.17,0.38,0.17h40.45c0,0,0,0,0,0c0.03,0,0.05,0,0.08-0.01 c0.02,0,0.03-0.01,0.05-0.02c0.03-0.01,0.06-0.02,0.09-0.04c0.03-0.01,0.05-0.03,0.08-0.05c0.02-0.02,0.05-0.04,0.07-0.06 c0.02-0.02,0.04-0.05,0.05-0.08c0.02-0.03,0.03-0.05,0.04-0.08C41.42,55.58,41.42,55.55,41.42,55.51z M39.94,52.47l0.42,2.49h-4.18 v-3.4c0-0.27-0.22-0.49-0.49-0.49c-0.27,0-0.49,0.22-0.49,0.49v3.4H21.21V45.3l2.01,2.35c0.09,0.1,0.22,0.17,0.36,0.17 c0.01,0,0.01,0,0.02,0c0.13,0,0.26-0.05,0.35-0.15L28,43.57l5.96,1.62C37.27,46.09,39.67,49,39.94,52.47z M27.2,42.97l-3.58,3.63 l-2.21-2.58l4.01-3.5L27.2,42.97z M27.97,36.03h-0.29c0.08-0.13,0.19-0.24,0.26-0.37c0.33-0.56,0.58-1.19,0.76-1.85h1.94 C30.41,35.07,29.3,36.03,27.97,36.03z M31.25,32.82h-2.34c0.07-0.46,0.12-0.94,0.12-1.43l0-4.24l2.3,0.06L31.25,32.82z  M13.85,16.19c2.53-2.64,6.19-3.44,10.3-2.24c2.29,0.63,4.17,2.1,5.32,4.14c1.29,2.3,1.56,5.14,0.8,8.05h-1.25l0-1.87 c-0.38-2.23-1.71-3.34-3.93-3.25c-0.64,0.02-1.31,0.17-2.05,0.45l-3.4,1.28c-0.7,0.26-1.46,0.36-2.19,0.3l-0.42-0.04 c-1.38-0.14-2.47,0.11-3.2,0.74c-0.61,0.53-0.97,1.34-1.1,2.39h-1.29C10.42,22.75,11.36,18.79,13.85,16.19z M12.66,32.81 l-2.37-0.06l0.07-5.62h2.3V32.81z M13.64,33.23v-6.58c0.05-1.02,0.32-1.72,0.82-2.15c0.52-0.45,1.35-0.62,2.47-0.51l0.42,0.04 c0.88,0.08,1.8-0.04,2.63-0.36l3.4-1.28c0.64-0.24,1.21-0.37,1.73-0.38c1.73-0.05,2.63,0.69,2.92,2.35v7.03 c0,1.42-0.33,2.73-0.94,3.77c-0.18,0.31-0.4,0.59-0.62,0.87h-4.21c-0.21-0.59-0.76-1.02-1.43-1.02c-0.83,0-1.51,0.68-1.51,1.51 c0,0.84,0.68,1.51,1.51,1.51c0.66,0,1.22-0.43,1.43-1.02h3.29c-0.23,0.21-0.49,0.4-0.75,0.58c-0.08,0.03-0.15,0.08-0.21,0.15 c-0.46,0.3-0.93,0.57-1.46,0.79c-1.41,0.59-2.99,0.62-4.45,0.08C16.04,37.64,14.4,35.88,13.64,33.23z M21.37,36.53 c0,0.29-0.24,0.53-0.53,0.53c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53C21.13,36,21.37,36.23,21.37,36.53z  M18.34,39.54c0.81,0.3,1.64,0.45,2.48,0.45c0.92,0,1.84-0.18,2.7-0.54c0.34-0.14,0.65-0.32,0.96-0.49v1.09l-3.75,3.28l-3.76-3.28 v-1.13C17.39,39.14,17.84,39.36,18.34,39.54z M16.01,40.52l4.01,3.5l-2.21,2.58l-3.58-3.63L16.01,40.52z M1.5,52.43 c0.26-3.43,2.67-6.33,5.99-7.24l5.96-1.62l4.05,4.11c0.09,0.09,0.22,0.15,0.35,0.15c0.01,0,0.01,0,0.02,0 c0.14,0,0.27-0.07,0.36-0.17l2.01-2.35v9.66H5.71v-3.4c0-0.27-0.22-0.49-0.49-0.49s-0.49,0.22-0.49,0.49v3.4H1.07L1.5,52.43z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 32.355,
    x2: 64,
    y1: 18.796,
    y2: 18.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M61.71,13h-9.96v-2.66c0-1.26-1.03-2.29-2.29-2.29h-14.8c-1.26,0-2.29,1.03-2.29,2.29l-0.01,8.68 c0,1.26,1.03,2.28,2.29,2.28h1.68l3.74,3.16c0.09,0.08,0.2,0.12,0.32,0.12c0.07,0,0.14-0.01,0.21-0.05 c0.17-0.08,0.29-0.25,0.29-0.45V21.3h3.74v2.67c0,1.26,1.03,2.28,2.29,2.28h8.58v2.79c0,0.19,0.11,0.37,0.29,0.45 c0.07,0.03,0.14,0.05,0.21,0.05c0.11,0,0.23-0.04,0.32-0.12l3.74-3.17h1.67c1.26,0,2.29-1.02,2.29-2.28v-8.68 C64,14.03,62.97,13,61.71,13z M40.4,20.32c-0.01,0-0.01,0-0.02,0c-0.14,0-0.26,0.06-0.35,0.15c-0.09,0.09-0.15,0.21-0.15,0.35 c0,0.01,0,0.02,0,0.02v2.2l-3.07-2.6c-0.04-0.03-0.08-0.05-0.12-0.07c-0.01,0-0.01-0.01-0.02-0.01c-0.05-0.02-0.11-0.03-0.17-0.03 c-0.01,0-0.01,0-0.02,0h-0.01c-0.01,0-0.02,0-0.03,0h-1.81c-0.72,0-1.31-0.58-1.31-1.3l0.01-8.68c0-0.72,0.59-1.31,1.31-1.31h14.8 c0.72,0,1.31,0.59,1.31,1.31V13h-3.86c-1.26,0-2.29,1.03-2.29,2.29v5.02H40.4z M63.02,23.97c0,0.72-0.59,1.3-1.31,1.3h-1.85 c-0.02,0-0.05,0.01-0.07,0.01c-0.03,0-0.06,0.01-0.1,0.02c-0.03,0.01-0.06,0.03-0.09,0.05c-0.02,0.01-0.04,0.02-0.06,0.03 l-3.07,2.6v-2.22c0-0.27-0.22-0.49-0.49-0.49h-9.07c-0.72,0-1.31-0.58-1.31-1.3v-8.68c0-0.72,0.59-1.31,1.31-1.31h14.8 c0.72,0,1.31,0.59,1.31,1.31V23.97z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 46.638,
    x2: 55.614,
    y1: 18.405,
    y2: 18.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M55.12,17.91h-7.99c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h7.99c0.27,0,0.49-0.22,0.49-0.49 C55.61,18.13,55.39,17.91,55.12,17.91z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 46.638,
    x2: 55.614,
    y1: 20.86,
    y2: 20.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M55.12,20.37h-7.99c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h7.99c0.27,0,0.49-0.22,0.49-0.49 C55.61,20.59,55.39,20.37,55.12,20.37z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 46.638,
    x2: 53.818,
    y1: 23.314,
    y2: 23.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M53.33,22.82h-6.2c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h6.2c0.27,0,0.49-0.22,0.49-0.49 C53.82,23.04,53.6,22.82,53.33,22.82z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 56.739,
    x2: 61.589,
    y1: 18.581,
    y2: 18.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M59.26,15.33c-0.53-0.02-1.88,0.13-2.5,2.14c-0.08,0.26,0.06,0.54,0.32,0.62c0.26,0.08,0.54-0.06,0.62-0.32 c0.3-0.96,0.81-1.48,1.51-1.45c0.63,0.03,1.25,0.54,1.37,1.13c0.12,0.59-0.28,1.14-1.07,1.54l-0.65,0.23 c-0.2,0.07-0.33,0.26-0.33,0.46v1.67c0,0.27,0.22,0.49,0.49,0.49s0.49-0.22,0.49-0.49v-1.32l0.38-0.13 c1.8-0.89,1.76-2.14,1.65-2.64C61.34,16.22,60.33,15.38,59.26,15.33z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 34.635,
    x2: 43.282,
    y1: 13.494,
    y2: 13.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M42.79,13h-7.66c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h7.66c0.27,0,0.49-0.22,0.49-0.49 C43.28,13.22,43.06,13,42.79,13z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 34.635,
    x2: 43.282,
    y1: 15.822,
    y2: 15.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M42.79,15.33h-7.66c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h7.66c0.27,0,0.49-0.22,0.49-0.49 C43.28,15.55,43.06,15.33,42.79,15.33z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 34.635,
    x2: 43.282,
    y1: 18.15,
    y2: 18.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335",
    className: "stopColor7b47d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    className: "stopColor5282e6 svgShape"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M42.79,17.66h-7.66c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h7.66c0.27,0,0.49-0.22,0.49-0.49 C43.28,17.88,43.06,17.66,42.79,17.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerRepresentative);
export default __webpack_public_path__ + "static/media/customer-representative.1e80aa6b18980447af5a30bd36870661.svg";
export { ForwardRef as ReactComponent };